'use strict';

const processInclude = require('base/util');
processInclude(require('./expressPayments/expressPaymentsObserver'));
